import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import {
  CommonProductService,
  ICommonProductService,
} from '@dewise-devex/backstage-plugin-product-common';
import {
  IUserProfileService,
  UserProfileService,
} from './api/UserProfileService';

export const commonProductApiRef = createApiRef<ICommonProductService>({
  id: 'plugin.user-profile.client',
});

export const userProfileApiRef = createApiRef<IUserProfileService>({
  id: 'plugin.user-profile.service',
});

export const userProfilePlugin = createPlugin({
  id: 'user-profile',
  apis: [
    createApiFactory({
      api: commonProductApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: deps => new CommonProductService(deps),
    }),
    createApiFactory({
      api: userProfileApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: deps => new UserProfileService(deps),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const UserProfilePage = userProfilePlugin.provide(
  createRoutableExtension({
    name: 'UserProfilePage',
    component: () =>
      import('./components/UserProfilePage').then(m => m.UserProfile),
    mountPoint: rootRouteRef,
  }),
);
